/**
 * Configuration class needed in base class.
 * The config is provided to the API client at initialization time.
 * API clients inherit from #AuthorizedApiBase and provide the config.
 */
import {UtilsService} from "../../services/utils.service";

let Client_ID = "moduleSante:teleExpertise:" + UtilsService.generateGUID();

export class IConfig {
	private readonly authService = import("../../services/auth.service");

	/**
	 * Returns a valid value for the Authorization header.
	 * Used to dynamically inject the current auth header.
	 */
	async getAuthorization() {
		return "Bearer " + (await this.authService).getToken();
	}
}

export class AuthorizedApiBase {
	private readonly config: IConfig;
	private readonly authService = import("../../services/auth.service");

	protected constructor(config: IConfig) {
		this.config = config;
	}

	async transformOptions(options: RequestInit): Promise<RequestInit> {
		options.headers = {
			...options.headers,
		};

		if (!window.config.dev) {
			// @ts-ignore Authorization n'est pas définit mais ça fonctionne
			options.headers!.Authorization = await this.config.getAuthorization();
		} else {
			// @ts-ignore
			options.headers["x-token-claims-idTechPs"] = (await this.authService).getIdTechPsConnectee();
		}

		return Promise.resolve(options);
	}
}

export type CancelToken = any;
